module.exports = __webpack_public_path__ + "img/sy-bottom.58378b54.png";